module.exports = __webpack_public_path__ + "images/img-GRxV9VR.png";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/dashboard/bday-city-popup-bg-ru.png
// module id = 1987
// module chunks = 0